import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';
import { PropertyCard } from '@/components/property/PropertyCard';
import { Skeleton } from '@/components/ui/skeleton';
import { Heart } from 'lucide-react';

export function SavedProperties() {
  const { user } = useAuth();

  const { data: properties, isLoading } = useQuery({
    queryKey: ['saved-properties', user?.id],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('favorites')
        .select('property_id, properties(*, property_images(*))')
        .eq('user_id', user!.id)
        .order('created_at', { ascending: false });
      if (error) throw error;
      return (data || []).map((f: any) => f.properties).filter(Boolean);
    },
    enabled: !!user,
  });

  return (
    <div className="space-y-6">
      <h2 className="font-display text-xl font-bold">Saved Properties</h2>

      {isLoading ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {Array.from({ length: 3 }).map((_, i) => <Skeleton key={i} className="h-72 rounded-xl" />)}
        </div>
      ) : properties && properties.length > 0 ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {properties.map((p: any) => <PropertyCard key={p.id} property={p} />)}
        </div>
      ) : (
        <div className="text-center py-20 text-muted-foreground">
          <Heart className="h-12 w-12 mx-auto mb-4" />
          <p>No saved properties yet</p>
        </div>
      )}
    </div>
  );
}
